var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001731",
    fillRule: "evenodd",
    d: "M24.5 12.493c0 6.623-5.373 11.992-12 11.992s-12-5.37-12-11.992C.5 5.869 5.873.5 12.5.5s12 5.37 12 11.993m-13.656.716L5.108 5.544h4.42l3.761 5.025 4.654-5.025h1.3l-5.373 5.801 6.058 8.095h-4.42l-4.083-5.456-5.054 5.457h-1.3zM9.049 6.5H7.02l8.968 11.983h2.03z",
    clipRule: "evenodd"
  })));
};
export default SvgTwitter;